import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useUserPathProjects } = getCRUDHooks({
  entityName: 'pathProjects',
  find: ({ userId, pathId }: { userId: number; pathId: number }) =>
    clientApi.getOCClient().helpers.learningActivity.paths.getProjects(userId, pathId),
});
// eslint-disable-next-line import/prefer-default-export
export { useUserPathProjects };
